export enum ServiceEventType {
  ERROR = 'ERROR',
  INFO = 'INFO',
}

export interface ServiceEvent {
  type: ServiceEventType;
  message: string;
  stacktrace: string;
  // these fields can be used for error grouping
  tags: {
    d_mod: string;
    d_os: string;
    d_p: string;
    tg_id: string;
    lib_n: string;
    lib_v: string;
  };
  // these are just fields of random data
  extra: {
    loc_app: string;
    user_lang: string;
    hn: string;
    br_w: string;
    br_h: string;
    src: string;
    place: string;
    r_url?: string;
    r_data?: string;
    [key: string]: string | number | undefined;
  };
}

export interface ServiceLoggerOptions {
  d_mod: string; // device model
  d_os: string; // device os
  d_p: string; // device platform
  loc_app: string; // locale app
  user_lang: string; // user locale
  tg_id: string; // telegramId
  lib_n: string; // lib name = MARKET || WRAPPER
  lib_v: string; // lib version
}

export enum LogDevMessageKinds {
  analytics = 'ANALYTICS',
  api = 'API',
  apiError = 'API_ERROR',
  error = 'ERROR',
  info = 'INFO',
  offline = 'OFFLINE',
  online = 'ONLINE',
  retry = 'RETRY',
  ws = 'WS',
}

export type MessageOrGetter<
  Message,
  Arguments extends unknown | undefined = undefined,
  Result = any,
> = ((message: Message, ...args: Arguments[]) => Result) | string;
